import { Cell } from "fixed-data-table-2"
import styled from "styled-components"

import { QuorumGrey2, QuorumTheme } from "design-constants"
import sheetConstants from "sheets/constants"

export const StyledFooterCell = styled(Cell)`
    width 100%;
    height: 100%;
    text-align: center;
    color: ${QuorumTheme.colors.gray[7]};
    font-size: ${sheetConstants.FONT_SIZE};
    font-weight: ${sheetConstants.FONT_WEIGHT};
`

export const CenteredDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

export const VerticallyCenteredDiv = styled.div`
    display: flex;
    align-items: center;
`

export const StyledPressIcon = styled.div`
    display: flex;
    width: 35px;
    height: 35px;
    justify-content: center;
    align-items: center;
    border: 2px solid ${QuorumGrey2};
    border-radius: 50%;
    margin-right: 9px;
    margin-left: -3px;
`
